import { render } from "./ProductProfile.vue?vue&type=template&id=e62d298c&scoped=true"
import script from "./ProductProfile.vue?vue&type=script&lang=js"
export * from "./ProductProfile.vue?vue&type=script&lang=js"

import "./ProductProfile.vue?vue&type=style&index=0&id=e62d298c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e62d298c"]])

export default __exports__